import { Text, Divider } from '@wework/dieter-ui'
import React from 'react'
import * as _ from 'lodash'
import Note from './Note'
import { NoteIcon } from '../Icons'

export default function NoteData({
  space,
  border = false,
  borderBottom = false,
  containerStyle = {},
}) {
  if (!space) {
    return null
  }
  const { reservable } = space

  if (!reservable) {
    return null
  }

  const note = _.get(reservable, 'note')
  const hasNote = note && note.trim() !== '0'

  if (!hasNote) {
    return null
  }

  return (
    <>
      <div
        style={{
          border: '0',
          display: 'flex',
          padding: '16px 0',
        }}
      >
        <Text style={{ width: 72 }}>
          <NoteIcon />
        </Text>
      </div>
      <div
        style={{
          border: '0',
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              border: '0',
              display: 'flex',
              alignItems: 'flex-start',
            }}
          >
            <div
              style={{
                position: 'relative',
                padding: '16px',
                borderRadius: '.25rem',
                border: border ? '1px solid #E6E6E6' : 0,
                ...containerStyle,
              }}
            >
              <Text size="tiny" style={{ fontWeight: '700' }}>
                Note
              </Text>
              <Text size="tiny">{note}</Text>
            </div>
            {borderBottom && <Divider light style={{ margin: 0 }} />}
          </div>
        </div>
      </div>
    </>
  )
}
